module.exports = __webpack_public_path__ + "static/media/resources.8732f41e.webp";